<div class="telephone-input" :class="classes">
    <input class="telephone-input__text" type="text" ref="telephoneInput" :value="telephoneNumber"
        @close:countrydropdown="onCountryChange"/>
</div>
